jQuery(document).ready(function ($) {

  //make megamenu parent menu item and title clickable
$(".has-mega-menu-1 .sub-menu-wrap h2").html($(".has-mega-menu-1 a").html());
var href1 = $('.has-mega-menu-1 a').prop('href');
$('.has-mega-menu-1 .sub-menu-wrap h2').wrap('<a href="' + href1 + '" class="wf-mega-parent"></a>');
$(".has-mega-menu-2 .sub-menu-wrap h2").html($(".has-mega-menu-2 a").html());
var href2 = $('.has-mega-menu-2 a').prop('href');
$('.has-mega-menu-2 .sub-menu-wrap h2').wrap('<a href="' + href2 + '" class="wf-mega-parent"></a>');


/* $('a[href*="/contact-us/"]').each(function() {
  if($(this).is(':contains("Request a Quote")')) {
    var querystring = '?form_select=Request a Quote';
    var href = $(this).attr('href');
    $(this).attr('href', href + querystring);
  }
}); */

// Scrollmagic for parallax block
var controller = new ScrollMagic.Controller();

$(".wrapper").each(function() {
  var tl = new TimelineMax();
  var child = $(this).find(".child");
  tl.to(child, 1, { y: -1580, ease: Linear.easeNone });

  var scene = new ScrollMagic.Scene({
    triggerElement: this,
    triggerHook: 0.4,
    duration: "150%"
  })
    .setTween(tl)
    //.addIndicators()
    .addTo(controller);
});




//wrap each card grid hover item on mousein, then remove on mouseout
if(window.matchMedia("(pointer: coarse)").matches) {
  // touchscreen
}else {

$('.card-grid-hover-item-inner').on("mouseenter", function() {
  var current = $(this);
  var anchor = current.find('a').first().attr('href');

  if(anchor){
    var wrapped = $(current).wrap('<a href="' + anchor + '"></a>');
  }
}).on("mouseleave", function() {
  var current = $(this);
  var anchor = current.find('a').first().attr('href');

  if(anchor){
    var wrapped = $(current).unwrap();
  }
});

}

/* $('.card-grid-hover-item-inner').each(function(){
  var current = $(this);
  var anchor = current.find('a').first().attr('href');

  if(anchor){
    var wrapped = $(current).wrap('<a href="' + anchor + '"></a>');
  }
}); */

});